export const basicTemplate = {
  $mode: 'basic',
  $types: {
    user: {
      pesho: 'string'
    }
  },
  $schema: './schema.graphql',
  $resolvers: {
    findUser: {
      gosho: 'omg',
      pesho: 515151,
      pesho2: 515151,
      pesho3: 515151,
      dadadada: 515151,
      pesho4: 515151,
      pesho5: [515151],
      pesho6: ['515151']
    },
    findUser2: {
      gosho: 'omg',
      pesho: 22,
      pesho2: 515151,
      pesho3: 515151,
      pesho4: 515151,
      pesho5: 515151
    }
  }
};
